import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Link from '@toasttab/shared/src/components/atoms/Link/Link'
import NavRegionSwitcher from './RegionMenu/NavRegionSwitcher'
import { useNavContext } from './useNavContext'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { determinePhoneAvailability } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/determinePhoneAvailability'

const UtilityNav = () => {
  const [isSalesAvailable, setIsSalesAvailable] = useState(false)
  const { t } = useI18next()
  const { globalSettings } = usePageContext()
  const {
    heapClasses,
    salesPhoneNumber,
    showLogin,
    showRestaurantSearch,
    showSalesInDesktopNav
  } = useNavContext()

  useEffect(() => {
    setIsSalesAvailable(
      determinePhoneAvailability(
        globalSettings?.mobileSalesIndicatorSchedule?.schedule
      )
    )
  }, [globalSettings])

  const baseLinkClasses = 'font-normal text-default hover:text-link'
  const restaurantLinkClasses = classNames(
    heapClasses.restaurantSearch,
    baseLinkClasses,
    'flex items-center before:content-icon-blue-map-marker before:block before:h-4 before:w-4 before:mr-1'
  )
  const salesLinkClasses = classNames(
    baseLinkClasses,
    'flex items-center before:content-icon-nav-sales before:block before:h-4 before:w-4 before:mr-1',
    'after:block after:content-[""] after:rounded-full after:w-1.5 after:h-1.5 after:ml-1',
    {
      'after:bg-gray-50': !isSalesAvailable,
      'after:bg-grass-50': isSalesAvailable
    }
  )
  const loginClasses = classNames(heapClasses.login, baseLinkClasses)
  const phoneHref = `tel:${salesPhoneNumber?.replace(/[^0-9]/gi, '')}`

  return (
    <div
      className='hidden lg:grid justify-end items-center grid-flow-col gap-4 pt-2 pb-1 px-4 lg:px-11 xl:px-0 text-xs leading-relaxed max-w-[1128px] m-auto w-full'
      data-testid='UtilityNav'
    >
      {showSalesInDesktopNav ? (
        <Link className={salesLinkClasses} to={phoneHref}>
          {t('Call Sales:')} {salesPhoneNumber}
        </Link>
      ) : null}
      {showRestaurantSearch ? (
        <Link
          className={restaurantLinkClasses}
          to='https://www.toasttab.com/local?referrer=pos'
        >
          {t('Find a Restaurant')}
        </Link>
      ) : null}
      <NavRegionSwitcher isUtilityNav />
      {/* todo - add option to show/hide this in Contentful */}
      <Link className={baseLinkClasses} to='https://support.toasttab.com'>
        {t('Customer Support')}
      </Link>
      {showLogin ? (
        <Link className={loginClasses} to='https://www.toasttab.com/login'>
          {t('Login')}
        </Link>
      ) : null}
    </div>
  )
}

export default UtilityNav
